/* Tunepike Theme JS */

// Quantity stepper
document.addEventListener('DOMContentLoaded', function () {

  // Quantity buttons
  document.querySelectorAll('.quantity-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = this.closest('.product-info__quantity').querySelector('input');
      var val = parseInt(input.value) || 1;
      if (this.dataset.action === 'minus') input.value = Math.max(1, val - 1);
      if (this.dataset.action === 'plus') input.value = val + 1;
    });
  });
  // Variant selector
  var variantForm = document.getElementById('AddToCartForm');
  var variantSelects = document.querySelectorAll('.product-info__option-select');
  var variantDataEl = document.getElementById('ProductVariantsJSON');

  if (variantForm && variantSelects.length && variantDataEl) {
    var variants = JSON.parse(variantDataEl.textContent);

    function getSelectedOptions() {
      var selected = [];
      variantSelects.forEach(function (select) {
        selected[parseInt(select.dataset.optionIndex)] = select.value;
      });
      return selected;
    }

    function findMatchingVariant(selected) {
      return variants.find(function (v) {
        return v.options.every(function (val, idx) {
          return val === selected[idx];
        });
      });
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function updateVariant() {
      var selected = getSelectedOptions();
      var match = findMatchingVariant(selected);
      if (!match) return;

      variantForm.querySelector('input[name="id"]').value = match.id;

      var priceEl = document.querySelector('.product-info__price');
      if (priceEl) priceEl.textContent = formatMoney(match.price);

      var comparePriceEl = document.querySelector('.product-info__compare-price');
      var saveEl = document.querySelector('.product-info__save');

      if (match.compare_at_price && match.compare_at_price > match.price) {
        if (comparePriceEl) {
          comparePriceEl.textContent = formatMoney(match.compare_at_price);
          comparePriceEl.style.display = '';
        }
        if (saveEl) {
          saveEl.textContent = 'Save ' + formatMoney(match.compare_at_price - match.price);
          saveEl.style.display = '';
        }
      } else {
        if (comparePriceEl) comparePriceEl.style.display = 'none';
        if (saveEl) saveEl.style.display = 'none';
      }

      var addBtn = document.getElementById('AddToCart');
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Add to cart' : 'Sold out';
      }
    }

    variantSelects.forEach(function (select) {
      select.addEventListener('change', updateVariant);
    });
  }

  // Gallery thumbnails
  document.querySelectorAll('.product-gallery__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var gallery = this.closest('.product-gallery');
      gallery.querySelectorAll('.product-gallery__thumb').forEach(function (t) {
        t.classList.remove('active');
      });
      this.classList.add('active');
      var mainImg = gallery.querySelector('.product-gallery__main img');
      if (mainImg && this.querySelector('img')) {
         mainImg.src = this.querySelector('img').dataset.fullSrc;
      }
    });
  });

  // Mobile menu toggle
  var menuBtn = document.querySelector('.mobile-menu-btn');
  var mobileMenu = document.querySelector('.mobile-menu');
  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', function () {
      mobileMenu.classList.toggle('open');
    });
  }

  // Sticky header shadow on scroll
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.style.boxShadow = window.scrollY > 10
        ? '0 2px 20px rgba(0,0,0,0.3)'
        : 'none';
    });
  }
});
